import CryptoJS from "crypto-js";

export const setUserLogin = (data) => ({
  type: "SET_USER_LOGIN",
  payload: data,
});

export const setWebBanner = (data) => ({
  type: "SET_WEB_BANNER",
  payload: data,
});

export const setLoginResponse = (data) => ({
  type: "SET_LOGIN_RESPONSE",
  payload: data,
});

export const setUserEmail = (data) => ({
  type: "SET_USER_EMAIL",
  payload: data,
});

export const setUserPassword = (data) => ({
  type: "SET_USER_PASSWORD",
  payload: data,
});

export const setUserPhone = (data) => ({
  type: "SET_USER_PHONE",
  payload: data,
});

export const setLoginMessage = (data) => ({
  type: "SET_LOGIN_MESSAGE",
  payload: data,
});

export const setAvailabilityMessage = (data) => ({
  type: "SET_AVAILABILITY_MESSAGE",
  payload: data,
});

export const setActivateAccountModal = (data) => ({
  type: "SET_ACTIVATE_ACCOUNT_MODAL",
  payload: data,
});

export const setActivateAccountOtpModal = (data) => ({
  type: "SET_ACTIVATE_ACCOUNT_OTP_MODAL",
  payload: data,
});

export const setActivateAccountEmail = (data) => ({
  type: "SET_ACTIVATE_ACCOUNT_EMAIL",
  payload: data,
});

export const setUpdatePasswordModal = (data) => ({
  type: "SET_UPDATE_PASSWORD_MODAL",
  payload: data,
});

export const setUpdatePasswordEmail = (data) => ({
  type: "SET_UPDATE_PASSWORD_EMAIL",
  payload: data,
});

export const setUpdatePasswordUsername = (data) => ({
  type: "SET_UPDATE_PASSWORD_USERNAME",
  payload: data,
});

export const setUpdatePasswordPin = (data) => ({
  type: "SET_UPDATE_PASSWORD_PIN",
  payload: data,
});

export const setUpdatePasswordNewPassword = (data) => ({
  type: "SET_UPDATE_PASSWORD_NEW_PASSWORD",
  payload: data,
});

export const setUpdatePasswordResponse = (data) => ({
  type: "SET_UPDATE_PASSWORD_RESPONSE",
  payload: data,
});

export const postLogin = (viewModel) => {
  return async function (dispatch) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/login-pnd/`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
          body: JSON.stringify(viewModel),
        }
      );
      
      const data = await response.json();

      // If the response contains an error or requires password setup/reset, return it immediately without logging in
      if (
        data &&
        (data.error ||
          data.password_set_required ||
          data.need_update_password ||
          data.need_reset_password ||
          !data.token)
      ) {
        return data;
      }

      // Encrypt and store credentials
      const passwordEncrypted = CryptoJS.AES.encrypt(
        JSON.stringify(viewModel.password),
        process.env.REACT_APP_SECRET_PASSWORD_KEY
      ).toString();

      const emailEncrypted = CryptoJS.AES.encrypt(
        JSON.stringify(viewModel.username),
        process.env.REACT_APP_SECRET_EMAIL_KEY
      ).toString();

      // Store in localStorage
      localStorage.setItem("email", emailEncrypted);
      localStorage.setItem("password", passwordEncrypted);
      localStorage.setItem("hashPasswordFlag", "true");
      localStorage.setItem("ID", data.user?.id);
      localStorage.setItem("Token", data.token);
      localStorage.setItem("first_name", data.user?.first_name);
      if (data.refresh_token) {
        localStorage.setItem("RefreshToken", data.refresh_token);
      } else if (data.refresh) {
        localStorage.setItem("RefreshToken", data.refresh);
      }
      // Update Redux state
      dispatch(setUserLogin(true));
      dispatch(setLoginResponse(data));
      return data;
    } catch (error) {
      console.error("Login error:", error);
      // Clear any existing credentials on error
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      localStorage.removeItem("hashPasswordFlag");
      localStorage.removeItem("ID");
      localStorage.removeItem("Token");
      localStorage.removeItem("userName");
      throw error;
    }
  };
};

export const postUpdatePassword = (viewModel) => {
  return async function (dispatch) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/setup-password/`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
          body: JSON.stringify(viewModel),
        }
      );
      const data = await response.json();
      dispatch(setUpdatePasswordResponse(data));
      return data;
    } catch (error) {
      console.error("postUpdatePassword error:", error);
      throw error;
    }
  };
};


export const requestOtpForInactive = (email) => {
  return async function (dispatch) {
    try {
      const response = await postData(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/request-otp/`,
        { email: email, for_inactive: true }
      );
      return response;
    } catch (error) {
      console.error("requestOtpForInactive error:", error);
      throw error;
    }
  };
};

export const activateAccount = (email, otp) => {
  return async function (dispatch) {
    try {
      const response = await postData(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/activate-account/`,
        { email: email, otp: otp }
      );
      return response;
    } catch (error) {
      console.error("activateAccount error:", error);
      throw error;
    }
  };
};

const postData = async (url = "", data = {}) => {
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
    },
    body: JSON.stringify(data),
  });
  return response.json(); // parses JSON response into native JavaScript objects
};

